import React from 'react';

import './App.css';
import NavBar from './component/NavBar/NavBar';
import Courses from './component/Pages/Courses/Courses';
import Home from './component/Pages/HomePage/Home';
import Login from './component/Pages/Login_Register/Login';
import SignUp from './component/Pages/Login_Register/SignUp';
import SingalTeacher from './component/Pages/SingalTeacher/SingalTeacher';
import SingleCourse from './component/Pages/SingleCourse/SingleCourse';
import {
  Switch,
  Route,
  useLocation
} from "react-router-dom";
import { AnimatePresence } from 'framer-motion';
import Footer from './component/Utilitis/Footer/Footer';
import SingalBlog from './component/Pages/SingalBlog/SingalBlog';
import Blogs from './component/Pages/Blogs/Blogs';
import ContactPage from './component/Pages/Contact/ContactPage';
import About from './component/Pages/About/About';

function App() {
  let location = useLocation();
  return (
    <>
      {/* <div className="fakeLoader"></div> */}
      <NavBar />
      <AnimatePresence exitBeforeEnter>
        <Switch location={location} key={location.key}>
          <Route exact path="/" component={Home} />
          <Route path="/signUp" component={SignUp} />
          <Route path="/signIn" component={Login} />
          <Route path="/singleCourse" component={SingleCourse} />
          <Route path="/singleBlog" component={SingalBlog} />
          <Route path="/singleTeacher" component={SingalTeacher} />
          <Route path="/courses" component={Courses} />
          <Route path="/blogs" component={Blogs} />
          <Route path="/contact" component={ContactPage} />
          <Route path="/about" component={About} />
        </Switch>
      </AnimatePresence>
      <Footer />
    </>
  );
}

export default App;

